// ─────────────────────────────────────────────
//  Testing-only user accounts.
//  These exist ONLY in code — no Firestore user docs, no Firebase Auth
//  accounts. When testing mode is ON (admin-toggled, per device) they are
//  injected into every staff dropdown and assignment list; when OFF they
//  vanish completely. Saved assignment rows store names alongside ids, so
//  rows created with a test account still render if the mode is later
//  turned off.
//
//  "Testing *" accounts exist to step into (perspective switching) and
//  validate each role's workflow; "Dummy *" accounts exist to populate
//  rooms with fake staff without using real provider names.
// ─────────────────────────────────────────────

export const TEST_USERS = [
  {
    id: "test-doctor",
    name: "Testing Doctor",
    role: "anesthesiologist",
    subRole: null,
    shortCode: "TDR",
    isTestAccount: true,
    description: "Assign rooms, assign breaks, view the board as a supervising doctor.",
  },
  {
    id: "test-crna",
    name: "Testing CRNA",
    role: "provider",
    subRole: "crna",
    isTestAccount: true,
    description: "See assigned rooms, relief assignments, and CRNA-level features.",
  },
  {
    id: "test-clinical",
    name: "Testing Clinical Staff",
    role: "provider",
    subRole: "aa",
    isTestAccount: true,
    description: "View assigned cases and board info at the clinical staff level.",
  },
  {
    id: "test-observer",
    name: "Testing Observer",
    role: "observer",
    subRole: null,
    isTestAccount: true,
    description: "Read-only access to the board and assignments.",
  },
  {
    id: "dummy-doctor",
    name: "Dummy Doctor",
    role: "anesthesiologist",
    subRole: null,
    shortCode: "DUM",
    isTestAccount: true,
    description: "Fake doctor for populating test assignments.",
  },
  {
    id: "dummy-crna",
    name: "Dummy CRNA",
    role: "provider",
    subRole: "crna",
    isTestAccount: true,
    description: "Fake CRNA for populating test assignments.",
  },
  {
    id: "dummy-observer",
    name: "Dummy Observer",
    role: "observer",
    subRole: null,
    isTestAccount: true,
    description: "Fake observer account.",
  },
];

export const testDoctors = () =>
  TEST_USERS.filter((u) => u.role === "anesthesiologist");

export const testProviders = () =>
  TEST_USERS.filter((u) => u.role === "provider");

export const isTestUserId = (id) =>
  !!id && TEST_USERS.some((u) => u.id === id);

export const testUserById = (id) =>
  TEST_USERS.find((u) => u.id === id) || null;
